export default __webpack_public_path__ + "static/media/mail 1.00d0fcd1.svg";